import * as Yup from 'yup';

// Defaults
export const formValues = {
    name: '',
    contact: '',
    street: '',
    zip: '',
    city: '',
    registrationNumber: '',
    buildingNumber: '',
    responsiblePerson: '',
}

export const validation = () => (
    Yup.object({
        name: Yup.string()
            .min(3, 'Minimálna dĺžka sú 3 znaky.')
            .max(25, 'Maximálna dĺžka je 25 znakov.')
            .required('Názov prevádzky je povinný.'),
        contact: Yup.string()
            .matches(/\+421[0-9]{9}/, 'Telefónne číslo nie je vo formáte slovenského čísla.')
            .min(13, 'Minimálny počet znakov je 13.')
            .max(13, 'Maximálny počet znakov je 13.')
            .required('Telefónne číslo je povinné'),
        street: Yup.string()
            .required('Ulica je povinná.')
            .min(5, 'Minimálny počet znakov je 5.')
            .max(50, 'Maximálny počet znakov je 50.'),
        zip: Yup.string()
            .required('PSČ je povinný.')
            .matches(/^\d*$/, 'PSČ nie je vo formáte slovenského PSČ.')
            .min(5, 'Minimálny počet znakov je 5.')
            .max(5, 'Maximálny počet znakov je 5.'),
        city: Yup.string()
            .required('Mesto je povinný.')
            .min(2, 'Minimálny počet znakov je 2.')
            .max(50, 'Maximálny počet znakov je 50.'),
        registrationNumber: Yup.number()
                .typeError('Súpisné číslo musí byť číslo')
                .max(9999999, 'Maximálny počet znakov je 25.'),
        buildingNumber: Yup.string()
            .max(25, 'Maximálny počet znakov je 25.'),
        responsiblePerson: Yup.string()
            .required('Zodpovedná osoba je povinná')
            .min(3, 'Minimálny počet znakov je 3.')
            .max(150, 'Maximálny počet znakov je 150.'),
    })
)